import { css, RuleSet } from 'styled-components';
import { atlasTypographyLengthToPx } from './typographyLengthPx';
import type { AtlasTypographyToken } from './typography';

export function textStyleCss(style: Readonly<AtlasTypographyToken>): RuleSet {
  return css`
    font-family: ${style.fontFamily};
    font-size: ${atlasTypographyLengthToPx(style.fontSize)};
    line-height: ${atlasTypographyLengthToPx(style.lineHeight)};
    font-weight: ${style.fontWeight};
    letter-spacing: ${atlasTypographyLengthToPx(style.letterSpacing)};
  `;
}

export function textStyleObject(style: Readonly<AtlasTypographyToken>) {
  return {
    fontFamily: style.fontFamily,
    fontSize: atlasTypographyLengthToPx(style.fontSize),
    lineHeight: atlasTypographyLengthToPx(style.lineHeight),
    fontWeight: style.fontWeight,
    letterSpacing: atlasTypographyLengthToPx(style.letterSpacing),
  };
}
